/**
 * Fundraising form: shared business-error union + mapper.
 *
 * Both form slices surface the same shape of failure: a coarse infra failure
 * (`network` | `api`, from the app-wide `@/utils/infra-error`) OR a business
 * `validation` failure carrying per-field messages. Add and Edit validate the
 * identical draft, so (unlike domains where the field maps diverge) the
 * mapper is shared too; each flow pins its own default message at the call
 * site. Infra/unexpected errors are not modelled here (they bubble to the
 * generic handler).
 */
import { classifyInfraError, type InfraFailure } from '@/utils/infra-error';

import type { ValidationErrors } from './fundraising-draft.model';

export type FundraisingFormError =
  | InfraFailure
  | { kind: 'validation'; fields: ValidationErrors };

export function toFundraisingFormError(e: unknown, defaultMessage: string): FundraisingFormError {
  return classifyInfraError(e, defaultMessage);
}
